import { FC } from 'react'
import { Row, Col, CardBlog } from '@/client/components'
import * as S from './styles'
import { NewsListProps } from '../types'

export const NewsList: FC<NewsListProps> = ({ news }) => (
  <Row>
    <Col>
      <S.NewsList>
        {news.map(({ link, image, title, description, tags, continue_reading }, index) => (
          <CardBlog
            key={title}
            kind='transparent'
            href={link}
            image={image}
            tags={tags}
            title={title}
            description={description}
            buttonLabel={continue_reading}
            priority={index < 9}
          />
        ))}
      </S.NewsList>
    </Col>
  </Row>
)
